import React from 'react';
import PropTypes from 'prop-types';

import '../variables.css';
import css from './radio.module.css';

function generateRandomId() {
  return 'a' + Math.random();
}

interface Props {
  id: string;
  disabled?: boolean;
  label: React.ReactNode;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  value: any;
}

/**
 * Primary UI component for user interaction
 */
export const Radio: React.FC<Props> = ({
  label,
  id,
  value,
  disabled,
  checked,
  onChange,
}) => {
  const inputId = id || generateRandomId();

  return (
    <label htmlFor={inputId} className={css.label}>
      <input
        disabled={disabled}
        checked={checked}
        value={value}
        id={inputId}
        type="radio"
        onChange={onChange}
      />
      <span className={css.wrapper}>
        <i className={css.icon} />
        <span>{label}</span>
      </span>
    </label>
  );
};

Radio.propTypes = {
  /*
   * Unique id to associate checkbox with
   */
  id: PropTypes.string,
  /**
   * Should the checkbox be in disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * Button contents
   */
  label: PropTypes.string.isRequired,
  /**
   * Handler function when checkbox state changes
   */
  onChange: PropTypes.func,
  value: PropTypes.any.isRequired,
};

Radio.defaultProps = {
  disabled: false,
};
